import React from "react";
import SysEventsDetailsView from "../cimponent/SysEventsDetailsView"; 

const SysEventsDetailsContainer = () => (<SysEventsDetailsView />)

export default SysEventsDetailsContainer;